<template>
    <div class="table-component">
        <table class="table">
            <thead>
                <tr>
                    <table-column-header
                            @click="changeSorting"
                            v-on:checked="emitToggleAll"
                            v-for="column in columns"
                            :key="column.show"
                            :sort="sort"
                            :column="column"
                    ></table-column-header>
                </tr>
            </thead>
            <tbody>
                <table-row
                        v-for="row in rows"
                        :key="row.vueTableComponentInternalRowId"
                        :row="row"
                        :columns="columns"
                        @rowClick="emitRowClick"
                ></table-row>
                <tr v-if="rows.length == 0">
                    <td :colspan="columns.length" class="text-center p-2">
                       <fa :icon="['fas','circle-notch']" spin v-if="loading" /> {{ loading ? 'Läser in artiklar...' : 'Inga artiklar' }}
                    </td>
                </tr> 
            </tbody>
            <tfoot>
                <slot name="tfoot" :rows="rows"></slot>
            </tfoot>
        </table>

        <div style="display:none;">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import Column from './classes/Column';
    import Row from './classes/Row';
    import TableColumnHeader from './TableColumnHeader';
    import TableRow from './TableRow';
    import { classList, pick } from './helpers';

    export default {
        components: {
            TableRow,
            TableColumnHeader
        },
        props : {
            data: { default: () => [], type: [Array, Function] },
            sort: { default: () => {}, type: [Object, Function] },
            loading : { default: true, type: Boolean }
        },
        watch : {
            data(new_data, old_data){
                this.mapDataToRows();
            }
        },
        data: () => ({
            columns: [],
            rows: [],
            filter: '',
            pagination: null,
        }),
        created(){
            this.sort.fieldName = this.sortBy;
            this.sort.order = this.sortOrder;
        },
        async mounted() {
            const columnComponents = this.$slots.default
                .filter(column => column.componentInstance)
                .map(column => column.componentInstance);

            this.columns = columnComponents.map(
                column => new Column(column)
            );

            columnComponents.forEach(columnCom => {
                if(columnCom.$options){
                    Object.keys(columnCom.$options.props).forEach(
                        prop => columnCom.$watch(prop, () => {
                            this.columns = columnComponents.map(
                                column => new Column(column)
                            );
                        })
                    );
                }
            });
            
            await this.mapDataToRows();
        },
        methods: {
            emitToggleAll(e){
                this.$emit('toggleChecked',e);
                this.$emit('toggle-checked',e);
            },
            emitRowClick(row) {
                this.$emit('rowClick', row);
                this.$emit('row-click', row);
            },
            changeSorting(col) {
                this.$emit('changeSorting', col);
                this.$emit('change-sorting', col);
            },
            async mapDataToRows() {
                let rowId = 0;
                let data = this.data;

                this.rows = data
                    .map(rowData => {
                        rowData.vueTableComponentInternalRowId = rowId++;
                        return rowData;
                    })
                    .map(rowData => new Row(rowData, this.columns));
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table/TableComponent.vue